<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>信息管理</el-breadcrumb-item>
      <el-breadcrumb-item>信息列表{{ pageType }}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="20">
             <el-radio-group  aria-hidden="false" v-model="queryInfo.CI_canshu03" @change="selectInfoType" style="margin-right:10px;">
        
            <el-radio label="1">我要买</el-radio>
            <el-radio label="2">我要卖</el-radio>
          </el-radio-group>
           
          <el-input
            placeholder="请输入查询内容"
            v-model="queryInfo.query"
            class="input-with-select"
            clearable
            style="width: 300px"
            @clear="getInfoList"
            @change="getInfoList"
          >
            <el-button slot="append" icon="el-icon-search" @click="getInfoList"></el-button>
          </el-input>
        </el-col>

        <!-- <el-col :span="4">
          <el-button type="primary" @click="addDialog" v-if="caozuo_type !== '1'">添加门店</el-button>
        </el-col> -->
      </el-row>

      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <el-table :data="InfoList" style="width: 100%" border stripe>
            <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->

            <el-table-column type="expand" v-if="pageType === 4">
              <template slot-scope="scope">
                <el-table :data="scope.row.mingxi_list" stripe style="background-color: #f0f9f9">
                  <el-table-column prop="mingxi_money" label="明细金额"></el-table-column>
                  <el-table-column prop="add_time" label="时间"></el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column prop="uid" label="uid" width="50"></el-table-column>
            <el-table-column prop="infoTitle" label="标题" width="400"></el-table-column>
            <el-table-column label="图片">
              <template slot-scope="scope03"> 
                <a :href="scope03.row.pic_one"  target="_blank"><img :src="scope03.row.pic_one" alt="" style="width:50px;height:50px;"></a>
              </template>
            </el-table-column>
            <el-table-column prop="typeName004" label="车型" width="400"></el-table-column>
            <el-table-column prop="guest_name" label="客户姓名" width="100"></el-table-column>
            <el-table-column prop="guest_mob" label="手机"></el-table-column>

            <el-table-column prop="jiage" label="出价"></el-table-column>
            <el-table-column label="审核标记">
              <template slot-scope="scope02">
                {{ formatStatus(scope02.row.shenhe_flag) }}
              </template>
            </el-table-column>
            <el-table-column prop="add_time" label="添加时间" width="200"></el-table-column>

            <el-table-column label="操作" v-if="caozuo_type !== '1'" width="100">
              <template v-slot="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="删除"
                  placement="top"
                  :enterable="false"
                >
                  <el-button
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    size="mini"
                    @click="deleteForm(scope.row.uid)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="审核"
                  placement="top"
                  :enterable="false"
                >
                  <el-button
                    type="primary"
                    icon="el-icon-ice-cream-round"
                    circle
                    size="mini"
                    @click="infoShenhe(scope.row.uid)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col> </el-row
      >
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.pageNum"
        :page-sizes="[10, 50]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
        <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
import { checkMobileTest } from './config/validator'

export default {
  components: {},
  /* 
   caozuo_type   1 浏览 2 管理修改删除
   pageType 1 可以进行选择  4 显示所有明细 
   mingxi_type 1 2  用来显示客户明细
   mingxiMain_type 1 2  显示门店明细类别
  */
  props: ['caozuo_type', 'pageType', 'mingxi_type', 'mingxiMain_type'],
  data() {
    // var checkMobile = (rule, value, cb) => {
    //  const regMobil = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
    // if (regMobil.test(value)) {
    //    return cb()
    //  }
    //  cb(new Error('请输入合法的手机号!'))
    //  }
    return {
      infoType: 1,
      yunying_Info_uid: 0,
      datekey: Date.now(),
      mendianUidSelect: 0,
      mendianUidInfo: {},
      // 获取用户列表参数
      queryInfo: {
        //   token: window.sessionStorage.getItem('token'), // 递交数据，必须携带token ，进行验证
        C_type: 'get_list_more',
        C_table_name: 'fabu_list_more',
        query: '',
        pageNum: 1,
        pageSize: 10,
        CI_canshu01: 0,
        CI_canshu02: 0,
        CI_canshu03: 0
      },
      InfoList: [],
      //  recordCount: 0,
      total: 0,
      addDialogVisible: false,
      editDialogVisible: false,
      shigongDialogVisible: false,
      kucunDialogVisible: false,
      rukuDialogVisible: false,
      chukuDialogVisible: false,

      add_isDisable: false,
      //  添加表单数据项
      addForm: {
        C_type: 'Info_add',
        Info_bianhao: '',
        Info_name: '',
        Info_lxr: '',
        Info_mob: '',
        Info_xuliehao: '',
        Info_type: ' ',
        Info_tel: ' ',
        Info_addr: ' ',
        pics_one: '',
        pics_shoukuanma: '',
        pics: ''
      },
      pics_one: '',
      pics: '',
      pics_shoukuanma: '',
      // 用于修改数据绑定
      editForm: {},
      // 表单规则项
      addFormRules: {
        Info_type: [{ required: true, message: '选择类型', trigger: 'change', type: 'number' }],
        Info_name: [
          { required: true, message: '请输入门店名称', trigger: 'blur' },
          { min: 1, max: 30, message: '必须1到30位字符 ', trigger: 'blur' }
        ],
        Info_lxr: [
          { required: true, message: '请输入门店管理员', trigger: 'blur' },
          { min: 1, max: 10, message: '必须1到10位字符', trigger: 'blur' }
        ],
        Info_mob: [{ validator: checkMobileTest.bind(this.addForm && this.addForm.Info_mob) }]
      }
    }
  },
  created() {
    this.getInfoList()
  },
  methods: {
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getInfoList()
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage
      this.getInfoList()
    },
    async getInfoList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      })
      // console.log(JSON.parse(res.data))
      this.InfoList = JSON.parse(res.data)[0].dataList
      console.log(this.InfoList)
      if (!this.InfoList) return
      this.total = JSON.parse(res.data)[0].total

      // console.log(this.total);
    },
    // 删除一条记录
    async deleteForm(InfoUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm('确定删除该条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      console.log(comfirmResult)
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除')
      const { data: res } = await this.$http.post('api', {
        C_type: 'record_delete',
        C_table_name: 'Info_del',
        C_data1: InfoUid
      })
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('删除失败')
        return
      }
      this.$message.success('删除成功')
      this.getInfoList()
    },
    // 审核信息

    async infoShenhe(InfoUid) {
      const comfirmResult = await this.$confirm('确定继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      console.log(comfirmResult)
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除')

      const { data: res } = await this.$http.post('api', {
        C_type: 'Info_shenhe',
        infoUid: InfoUid,
        type: 1
      })
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('设置失败')
        return
      }
      this.$message.success('设置成功')
      this.getInfoList()
    },
    formatStatus(status) {
      switch (status) {
        case 0:
          return '未审核'
        case 1:
          return '已审核'

        default:
          return '未知状态'
      }
    },
    selectInfoType(i) {
      this.getInfoList()
    }
  }
}
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
}

.el_row_two {
  margin-top: 30px;
}
</style>
